import { createAction } from '@reduxjs/toolkit'
import { DialogSettings, Dialogs } from 'shared/types'

const NAMESPACE = 'ui'

export const setDialogContent = createAction<Omit<DialogSettings, 'isOpen'>>(
  `${NAMESPACE}/setDialogContent`
)
export const clearDialog = createAction(`${NAMESPACE}/clearDialog`)
export const toggleDialog = createAction(`${NAMESPACE}/toggleDialog`)
export const setDialogOpenState = createAction<boolean>(
  `${NAMESPACE}/setDialogOpenState`
)

export const patchDialogsState = createAction<Partial<Dialogs>>(
  `${NAMESPACE}/patchDialogsState`
)

export const openBankTransferVerificationDialog = createAction(
  `${NAMESPACE}/openBankTransferVerificationDialog`
)
export const closeBankTransferVerificationDialog = createAction(
  `${NAMESPACE}/closeBankTransferVerificationDialog`
)

export const openLawsuitSignatureDialog = createAction(
  `${NAMESPACE}/openLawsuitSignatureDialog`
)
export const closeLawsuitSignatureDialog = createAction(
  `${NAMESPACE}/closeLawsuitSignatureDialog`
)

export const openUploadFiledLawsuitDialog = createAction(
  `${NAMESPACE}/openUploadFiledLawsuitDialog`
)
export const closeUploadFiledLawsuitDialog = createAction(
  `${NAMESPACE}/closeUploadFiledLawsuitDialog`
)

export const openUpdateLawsuitDialog = createAction(
  `${NAMESPACE}/openUpdateLawsuitDialog`
)
export const closeUpdateLawsuitDialog = createAction(
  `${NAMESPACE}/closeUpdateLawsuitDialog`
)
